// Estados y fases del helicóptero y botones
export const EXT_STATE = {
  NOT_STARTED: "notStarted", // Estado inicial, sin iniciar
  FLY_APPROACHING: "flyApproaching",   // Animación de entrada, acercándose. No muestra boton. Cuando das tap to start
  FLY_IDLE: "flyIdle",                 // Vuelo estacionario, muestra btn Vertical land
  FLY_LANDING: "flyLanding",           // Animación de aterrizaje
  LANDED: "landed",                    // Estado final tras aterrizar
  FLY_LEAVING: "flyLeaving",           // Animación de despegue
  PARTNERSHIP: "partnership"          // Estado especial (ej: colaboración)
};

/**
 * TODO Revisar cómo aplica estos estados el flight button en el interior y ver si 
 * pasarlos al componente de laesfera para reproducir el video correspondiente desde ahi
 */
export const INT_STATE = {
  LANDED: "landed",
  TAKEOFF: "takeoff",
  FLYING: "flying"
};

